import { type UserInfo } from "helpers/AppProvider.types";

import { BTLoginTypes } from "types/enum";

import { createRoute } from "utilities/flatRoutes/routes";

export const getClientUpdateViewRoute = (user: UserInfo) => {
    const pathRoot = user?.loginType === BTLoginTypes.CONTACT ? "/Summary" : "/ClientUpdates";
    return createRoute<{
        id: number;
    }>(pathRoot + `/ClientUpdate/:id`, "Client Updates");
};
